import React from 'react';
import { motion } from 'framer-motion';
import { WarningIcon, XIcon } from './icons';
export function WhyOthersFail() {
  const failures = [{
    title: 'El contratista barato',
    desc: 'que usó materiales de segunda y el trabajo duró 6 meses'
  }, {
    title: 'La empresa grande',
    desc: 'que mandó a alguien diferente cada día, sin coordinación'
  }, {
    title: 'El "amigo de un amigo"',
    desc: 'que cobró adelantado y nunca terminó'
  }, {
    title: 'El que no hablaba español',
    desc: 'y había malentendidos en todo el proceso'
  }];
  return <section className="py-24 bg-brand-bg-light" data-id="element-335">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-337">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-338">
            <WarningIcon className="w-10 h-10 text-brand-red" data-id="element-339" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-340">
              Por Qué Los Otros Fallan
            </h2>
          </div>

          <p className="text-xl text-gray-300 text-center mb-12" data-id="element-341">
            Hemos escuchado las mismas historias cientos de veces:
          </p>

          <div className="space-y-6 mb-16" data-id="element-342">
            {failures.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-brand-bg-dark p-6 rounded-lg border border-brand-red/20 hover:border-brand-red/50 transition-colors" data-id="element-343">
                <div className="mt-1 bg-brand-red/10 p-2 rounded-full flex-shrink-0" data-id="element-344">
                  <XIcon className="w-6 h-6 text-brand-red" data-id="element-345" />
                </div>
                <div data-id="element-346">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-347">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-lg" data-id="element-348">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="bg-brand-red/5 border-l-4 border-brand-red p-8 rounded-r-lg" data-id="element-349">
            <p className="text-xl sm:text-2xl text-white mb-4" data-id="element-350">
              El problema no es solo la mano de obra — es la{' '}
              <strong className="text-brand-red font-heading tracking-wide" data-id="element-351">
                falta de compromiso personal.
              </strong>
            </p>
            <p className="text-lg text-gray-300 italic" data-id="element-352">
              Cuando el dueño no es el que trabaja, nadie le importa tu casa
              tanto como a ti.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}